<template>
  <div class="timer min-h-100">
    <timer-display></timer-display>
  </div>
</template>

<script>
  // @ is an alias to /src
  import TimerDisplay from "@/components/timer-display.vue"

  export default {
    name: "timer",
    components: { TimerDisplay }
  }
</script>
